import * as React from 'react';

import { RedesignedFiltersPanelId } from './index';
import * as styles from './styles.css';
import { ETestId } from '../../../common/constants';
import { FILTER_COMPONENTS } from '../../constants/filtersComponents';
import { useFiltersList } from '../../hooks/useFiltersList';

export const RedesignedFiltersPanelContainer = () => {
  const filtersList = useFiltersList();

  return (
    <section id={RedesignedFiltersPanelId} data-testid={ETestId.RedesignedFiltersSectionTestId}>
      <div className={styles['chips']}>
        {filtersList.map(filterKey => {
          const Component = FILTER_COMPONENTS[filterKey];

          return <Component key={filterKey} />;
        })}
      </div>
    </section>
  );
};
